import { IconButton, List, ListItem, ListItemButton, ListItemText, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { PendingLoanApprovalTablePropsType } from "../../../types/container.type";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const PendingLoanApprovalTable: React.FC<PendingLoanApprovalTablePropsType> = ({ rows, handleActionButtonClick, selectedLoanId, dropdownRef, handleActionItemClick }) => {
    const actions = ["Approve", "Decline"];
    const pendingLoanApprovalTableHeaders = ["Loan ID", "Loan Product", "Obligor", "Disbursed Amount", "Total Payable", "Status", "Action"];

    return (
        <BaseTable
            headers={pendingLoanApprovalTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => (
                    <TableRow key={index}>
                        <TableCell>{row?.serialNo.toString().padStart(3, '0')}</TableCell>
                        <TableCell>
                            {row?.loanProduct
                                ?.replace(/\b\w/g, (char: string) => char.toUpperCase())}
                        </TableCell>
                        <TableCell>{row?.obligor}</TableCell>
                        <TableCell>{formatAmountDisplay(row?.appliedAmount ?? 0)}</TableCell>
                        <TableCell>{formatAmountDisplay(row?.totalPayable ?? 0)}</TableCell>
                        <TableCell>
                            {row?.status
                                ?.replace(/\b\w/g, (char: string) => char.toUpperCase())}
                        </TableCell>
                        <TableCell>
                            <IconButton
                                sx={{
                                    borderRadius: "0.5rem",
                                    backgroundColor: "var(--sky-blue-color)",
                                    "&:hover": {
                                        backgroundColor: "var(--sky-blue-color)"
                                    }
                                }}
                                onClick={(e) => handleActionButtonClick(e, { id: row?.id, serialNo: row?.serialNo, institution: row?.institution, obligor: row?.obligor, amountDisbursed: row?.appliedAmount, totalPayable: row?.totalPayable })}
                            >
                                <MoreVertIcon
                                    sx={{
                                        color: "#FFFFFF",
                                        display: "inline-flex",
                                    }}
                                />
                            </IconButton>
                            {(selectedLoanId && selectedLoanId === row?.id) && (
                                <List
                                    component={"ul"}
                                    ref={dropdownRef}
                                    className="dropdown-modal"
                                >
                                    {actions.map((action, index) => (
                                        <ListItem
                                            key={index}
                                            onClick={(e) => handleActionItemClick(e, selectedLoanId, action)}
                                        >
                                            <ListItemButton>
                                                <ListItemText
                                                    primary={action}
                                                />
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </BaseTable >
    )
}